type MobileSidebarToggleProps = {
  onClick: () => void;
};

/** Hamburger button used in the header to open the mobile sidebar. */
export const MobileSidebarToggle = ({ onClick }: MobileSidebarToggleProps) => (
  <button
    type="button"
    onClick={onClick}
    className="inline-flex min-h-[44px] min-w-[44px] items-center justify-center rounded-md text-fg-subtle transition-colors hover:bg-surface-muted hover:text-fg-base active:bg-surface-subtle lg:hidden"
    aria-label="Ouvrir la navigation"
  >
    <svg
      className="h-5 w-5"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <line x1="3" y1="6" x2="21" y2="6" />
      <line x1="3" y1="12" x2="21" y2="12" />
      <line x1="3" y1="18" x2="21" y2="18" />
    </svg>
  </button>
);
